module.exports = __webpack_public_path__ + "img/health37_7-9-2021.99197ec4.jpg";